export class ManagementListDebounce {
  private timeout: ReturnType<typeof setTimeout> | null = null;

  schedule(callback: () => void, delay = 300) {
    this.clear();
    this.timeout = setTimeout(() => {
      this.timeout = null;
      callback();
    }, delay);
  }

  clear() {
    if (!this.timeout) {
      return;
    }

    clearTimeout(this.timeout);
    this.timeout = null;
  }
}
